"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DeleteOverlay = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
require("core-js/modules/es.function.name.js");
var _components = require("./components");
var _formElements = require("@evidation/form-elements");
var _react = _interopRequireDefault(require("react"));
var _useTranslated = require("../../hooks/useTranslated");
var _excluded = ["onClick", "name", "disabled"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var DeleteOverlay = exports.DeleteOverlay = function DeleteOverlay(_ref) {
  var overlay = _ref.overlay,
    onDelete = _ref.onDelete,
    toggleOverlayOn = _ref.toggleOverlayOn,
    toggleOverlayOff = _ref.toggleOverlayOff,
    name = _ref.name;
  if (!overlay) {
    return /*#__PURE__*/_react["default"].createElement(_components.DeleteImage, {
      onClick: toggleOverlayOn
    }, "X");
  }
  return /*#__PURE__*/_react["default"].createElement(_components.DeleteImageOverlay, null, /*#__PURE__*/_react["default"].createElement(_components.RemoveHeading, null, (0, _useTranslated.useTranslated)('components.uploader.removeHeading')), /*#__PURE__*/_react["default"].createElement(_formElements.Button, {
    style: {
      padding: "0px"
    },
    buttonStyle: "achievement",
    onClick: function onClick() {
      return onDelete(name);
    }
  }, (0, _useTranslated.useTranslated)('components.uploader.removeImage')), /*#__PURE__*/_react["default"].createElement(_formElements.Button, {
    buttonStyle: "achievement_text",
    onClick: toggleOverlayOff
  }, (0, _useTranslated.useTranslated)('components.uploader.cancel')));
};
var Preview = /*#__PURE__*/function (_React$PureComponent) {
  function Preview(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Preview);
    _this = _callSuper(this, Preview, [props]);
    _this.state = {
      overlay: false
    };
    return _this;
  }
  (0, _inherits2["default"])(Preview, _React$PureComponent);
  return (0, _createClass2["default"])(Preview, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var overlay = this.state.overlay;
      var _this$props = this.props,
        onClick = _this$props.onClick,
        name = _this$props.name,
        disabled = _this$props.disabled,
        rest = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_components.UploadPictureContainer, (0, _extends2["default"])({}, rest, {
        overlay: overlay
      }), !disabled && /*#__PURE__*/_react["default"].createElement(DeleteOverlay, {
        overlay: overlay,
        onDelete: onClick,
        toggleOverlayOn: function toggleOverlayOn() {
          return _this2.setState({
            overlay: true
          });
        },
        toggleOverlayOff: function toggleOverlayOff() {
          return _this2.setState({
            overlay: false
          });
        }
      }));
    }
  }]);
}(_react["default"].PureComponent);
Preview.propTypes = {};
var _default = exports["default"] = Preview;